<script setup lang="ts">
import { QrCode } from 'lucide-vue-next'
</script>

<template>
  <QrCode />
</template>
